import { canUseDOM } from '../../../utils';
var falseState = {
  failed: true
};
var successState = {
  success: true
};
var storageName = 'top-picks';
var FETCH_TIMEOUT = 30000;
export var deleteTopPicksStorage = function deleteTopPicksStorage() {
  if (canUseDOM) {
    localStorage.removeItem(storageName);
  }
};
export var getTopPicks = function getTopPicks(accessToken, apiGlobal) {
  return new Promise(function (resolve) {
    var timeout = setTimeout(function () {
      resolve(false);
    }, FETCH_TIMEOUT);
    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Bearer ".concat(accessToken));
    myHeaders.append('Content-Type', 'application/json');
    var graphql = JSON.stringify({
      query: '{user{topPicks{itemId}}}',
      variables: {}
    });
    var requestOptions = {
      method: 'POST',
      redirect: 'follow',
      body: graphql,
      headers: myHeaders
    };
    var statusCode = 0;
    fetch("".concat(apiGlobal, "/graphql/user"), requestOptions).then(function (response) {
      clearTimeout(timeout);
      statusCode = response.status;
      return response.text();
    }).then(function (result) {
      clearTimeout(timeout);
      var responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.data) {
          resolve(responseObj.data.user.topPicks);
        } else {
          resolve(falseState);
        }
      }
      resolve(falseState);
    }).catch(function (error) {
      resolve(falseState);
    });
  });
};
export var removeTopPicks = function removeTopPicks(accessToken, topPickIds, apiGlobal) {
  return new Promise(function (resolve) {
    var timeout = setTimeout(function () {
      resolve(false);
    }, FETCH_TIMEOUT);
    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Bearer ".concat(accessToken));
    myHeaders.append('Content-Type', 'application/json');
    var graphql = JSON.stringify({
      query: "mutation removeTopPicks{removeTopPick(itemIds: ".concat(JSON.stringify(topPickIds), " ){itemId,created}}"),
      variables: {}
    });
    var requestOptions = {
      method: 'POST',
      redirect: 'follow',
      body: graphql,
      headers: myHeaders
    };
    var statusCode = 0;
    fetch("".concat(apiGlobal, "/graphql/user"), requestOptions).then(function (response) {
      clearTimeout(timeout);
      statusCode = response.status;
      return response.text();
    }).then(function (result) {
      var responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.data) {
          resolve(successState);
        }
      }
      resolve(falseState);
    }).catch(function (error) {
      clearTimeout(timeout);
      resolve(falseState);
    });
  });
};
export var addTopPicks = function addTopPicks(accessToken, topPickIds, apiGlobal) {
  return new Promise(function (resolve) {
    var timeout = setTimeout(function () {
      resolve(false);
    }, FETCH_TIMEOUT);
    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Bearer ".concat(accessToken));
    myHeaders.append('Content-Type', 'application/json');
    var graphql = JSON.stringify({
      query: "mutation addTopPicks{addTopPick(itemIds: ".concat(JSON.stringify(topPickIds), " ){itemId,created}}"),
      variables: {}
    });
    var requestOptions = {
      method: 'POST',
      redirect: 'follow',
      body: graphql,
      headers: myHeaders
    };
    var statusCode = 0;
    fetch("".concat(apiGlobal, "/graphql/user"), requestOptions).then(function (response) {
      clearTimeout(timeout);
      statusCode = response.status;
      return response.text();
    }).then(function (result) {
      var responseObj;
      if (result) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (responseObj.data) {
          resolve(successState);
        }
      }
      resolve(falseState);
    }).catch(function (error) {
      clearTimeout(timeout);
      resolve(falseState);
    });
  });
};
export var getEmptyTopPicksStorage = function getEmptyTopPicksStorage(list) {
  var newObject = {
    list: list,
    sync: true,
    added: [],
    removed: []
  };
  return newObject;
};
export var getTopPicksStorage = function getTopPicksStorage() {
  if (canUseDOM) {
    if (localStorage.getItem(storageName) === null) {
      var newObject = {
        list: [],
        sync: true,
        added: [],
        removed: []
      };
      localStorage.setItem(storageName, JSON.stringify(newObject));
      return newObject;
    } else {
      return JSON.parse(localStorage.getItem(storageName) || '');
    }
  } else {
    return {
      list: [],
      sync: true,
      added: [],
      removed: []
    };
  }
};
export var setTopPicksStorage = function setTopPicksStorage(topPicks) {
  if (canUseDOM) {
    if (!topPicks.list) topPicks.list = [];
    localStorage.setItem(storageName, JSON.stringify(topPicks));
  }
};
export var syncTopPicks = function syncTopPicks(accessToken, apiGlobal) {
  var topPicks = getTopPicksStorage();
  return new Promise(function (resolve) {
    if (topPicks.added.length) {
      addTopPicks(accessToken, topPicks.added, apiGlobal).then(function (state) {
        if (state.success) {
          if (topPicks.removed.length) {
            removeTopPicks(accessToken, topPicks.removed, apiGlobal).then(function (state) {
              if (state.success) {
                resolve(true);
              } else {
                resolve(false);
              }
            });
          } else {
            resolve(true);
          }
        } else {
          resolve(false);
        }
      });
    } else if (topPicks.removed.length) {
      removeTopPicks(accessToken, topPicks.removed, apiGlobal).then(function (state) {
        if (state.success) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    } else {
      resolve(true);
    }
  });
};